import Taxes from 'containers/product-catalog/taxes/Taxes';
import { selectIsActionsBlocked } from 'containers/app/appSlice';
import { useAppSelector } from 'hooks';
import { FC } from 'react';
import MerchantOrTeamBlockedInfo from 'components/merchant-or-team-blocked/MerchantOrTeamBlockedInfo';

const TaxesPage: FC = () => {
  const isActionsBlocked = useAppSelector(selectIsActionsBlocked);
  if (isActionsBlocked) {
    return <MerchantOrTeamBlockedInfo title="Taxes" />;
  }
  return <Taxes />;
};

export default TaxesPage;
